import request from '@/assets/js/myAxios'

export async function GetCartList(data) {
  return request({
    url: '/api/mall_Cart/GetCartList?id='+data,
    method: 'get',
  })
}


export async function UpdateCart(id,data) {
  return request({
    url: '/api/mall_Cart/UpdateCart?id='+id,
    method: 'post',
    data: data
  })
}

export async function AddCart(id,data) {
  return request({
    url: '/api/mall_Cart/AddCart?id='+id,
    method: 'post',
    data: data
  })
}

export async function DeleteCart(id,data) {
  return request({
    url: '/api/mall_Cart/DeleteCart?id='+id,
    method: 'post',
    data: data
  })
}






